import { ActionType, createAction } from 'typesafe-actions';

export const reportProblem = createAction('REPORT_PROBLEM')<void>();

export const openFreshchat = createAction('OPEN_FRESHCHAT')<void>();

export type ReportActions = ActionType<
  typeof reportProblem | typeof openFreshchat
>;
